import { PrismTheme } from 'prism-react-renderer';

export const DCBrandedTheme: PrismTheme = {
  plain: {
    color: 'rgb(var(--color-base-black))',
    backgroundColor: 'transparent',
  },
  styles: [
    {
      types: ['comment', 'prolog', 'doctype', 'cdata'],
      style: {
        color: 'rgb(var(--color-gray-400))',
      },
    },
    {
      types: ['punctuation'],
      style: {
        color: 'rgb(var(--color-gray-600))',
      },
    },
    {
      types: ['namespace'],
      style: {
        color: 'rgb(var(--color-brand-500))',
      },
    },
    {
      types: ['property'],
      style: {
        color: 'rgb(var(--color-warning-500))',
      },
    },
    {
      types: ['tag', 'boolean', 'number', 'constant', 'symbol'],
      style: {
        color: 'rgb(var(--color-brand-700))',
      },
    },
    {
      types: ['selector', 'attr-name', 'string', 'char', 'builtin', 'inserted'],
      style: {
        color: 'rgb(var(--color-tertiary-500))',
      },
    },
    {
      types: [
        'operator',
        'entity',
        'url',
        'string',
        'variable',
        'language-css',
        'string',
      ],
      style: {
        color: 'rgb(var(--color-error-200))',
      },
    },
    {
      types: ['atrule', 'attr-value', 'keyword', 'function', 'class-name'],
      style: {
        color: 'rgb(var(--color-brand-500))',
      },
    },

    {
      types: ['regex', 'important'],
      style: {
        color: 'rgb(var(--color-tertiary-300))',
      },
    },
    {
      types: ['important', 'bold'],
      style: {
        fontWeight: 'bold',
      },
    },
    {
      types: ['italic'],
      style: {
        fontStyle: 'italic',
      },
    },
    {
      types: ['entity'],
      style: {
        cursor: 'help',
      },
    },
  ],
};
